const VIEW_JOBS_MEMBERS_ONLY = 'VIEW_JOBS_MEMBERS_ONLY';
const MANAGE_ARTICLES = 'MANAGE_ARTICLES';
const VIEW_RECRUITER_TOOLS = 'VIEW_RECRUITER_TOOLS';
const VIEW_CANDIDATE_RECOMMENDATIONS = 'VIEW_CANDIDATE_RECOMMENDATIONS';
const POST_JOBS = 'POST_JOBS';
const ACCESS_DEVEX_CPANEL = 'ACCESS_DEVEX_CPANEL';
const MANAGE_CURATED_LISTS = 'MANAGE_CURATED_LISTS';
const EVENT_RELATED_PRIVILEGES_REGEX = /CAN_ATTEND_[A-Z]+_EVENT/;
const DOWNLOADABLE_RELATED_PRIVILEGES_REGEX = /CAN_DOWNLOAD_[A-Z]+_CONTENT/;
export {
  VIEW_JOBS_MEMBERS_ONLY,
  MANAGE_ARTICLES,
  VIEW_RECRUITER_TOOLS,
  VIEW_CANDIDATE_RECOMMENDATIONS,
  POST_JOBS,
  EVENT_RELATED_PRIVILEGES_REGEX,
  DOWNLOADABLE_RELATED_PRIVILEGES_REGEX,
  ACCESS_DEVEX_CPANEL,
  MANAGE_CURATED_LISTS,
};
